import "./TheCarefulConsulting.module.css";
import Header from "@/reusable_sections/Header";
import CraftingTheNextHorizon from "./sections/CraftingTheNextHorizon";
import OurGlobalFootprint from "./sections/OurGlobalFootprint";
import TheGrowthArchitecture from "./sections/TheGrowthArchitecture";
import TheLeadershipBench from "./sections/TheLeadershipBench";
import TheSupplyChainNexus from "./sections/TheSupplyChainNexus";
import DirectConsultation from "./sections/DirectConsultation";
import Footer from "@/reusable_sections/Footer";
export default function TheCarefulConsultingPage() {
  return <div>
      <Header />
      <CraftingTheNextHorizon />
      <OurGlobalFootprint />
      <TheGrowthArchitecture />
      <TheLeadershipBench />
      <TheSupplyChainNexus />
      <DirectConsultation />
      <Footer />
    </div>;
}